import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { toastAdd } from 'mk2/actions';
import CommentList from 'mk2/apps/blogs/components/CommentList';
import {
    commentCreate,
    commentDelete,
    commentReply,
    commentsLoad,
} from 'mk2/apps/blogs/containers/Comments/Comments.actions';
import {
    getCommentsCanAdd,
    getCommentsComments,
    getCommentsErrorMessage,
    getCommentsLoadingState,
    getCommentsNonDeletedComments,
} from 'mk2/apps/blogs/reducers';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { getModelAndId } from 'mk2/apps/blogs/utils';
import { postSendHeart } from 'mk2/apps/forum/actions';
import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import LoadError from 'mk2/components/errors/LoadError';
import ServerErrorToast from 'mk2/components/toasts/ServerErrorToast';
import { complaintInitToggle } from 'mk2/containers/Complaint/Complaint.actions';
import { likeToggle } from 'mk2/containers/Like/Like.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import {
    AppState,
    getComplaintShow,
    getRequestDeviceIsIOS,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    getResponseRenderedAt,
} from 'mk2/reducers';
import { isFailure, LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { subscribeJam, unsubscribeJam } from 'mk2/services/jam';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import styles from './Comments.mscss';

interface OwnProps {
    postKey: string;
    count: number;
    inGroups?: boolean;
    inPrivateGroup?: boolean;
    isPreloaded?: boolean;
    moderators?: UserEntity[];

    onToggleMenuMore?(id: number);
}

interface StateProps {
    comments: CommentEntity[];
    loadingState: LoadingState;
    errorMessage: string;
    canAdd: boolean;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    renderedAt: number;
    isIOS: boolean;
    mobile: boolean;
    initialValues: CommentFormData;
    complaintsOpened: boolean[];
}

interface DispatchProps {
    onLoad(key: string);
    onCreate(commentFd: CommentFormData, key: string);
    onLike(entity: string, id: number);
    onDelete(commentId: number, key: string);
    onReport(entityType: string, commentId: number);
    onReply(id: number, username: string);

    onFailureToast();
    onSendHeart();
}

type RouteProps = RouteComponentProps<void>;

type Props = OwnProps & StateProps & DispatchProps & RouteProps;

class Comments extends React.Component<Props> {

    public shouldComponentUpdate(n: Props) {
        const p = this.props;

        if (p.comments.length === n.comments.length) {
            for (let i = 0; i < p.comments.length; i++) {
                if (p.comments[i].likeable.likesCount !== n.comments[i].likeable.likesCount) {
                    return true;
                }
            }
        } else {
            return true;
        }

        return p.complaintsOpened.join() !== n.complaintsOpened.join()
            || p.loadingState !== n.loadingState
            || p.moderators !== n.moderators
            || p.canAdd !== n.canAdd;
    }

    // public componentWillMount() {
    //     const { loadingState, renderedAt } = this.props;
    //
    //     // Load only if not loaded on server and is not older than 30s
    //     if (loadingState !== LoadingState.SUCCESS_ON_SERVER || renderedAt < Date.now() - 30 * 1000) {
    //         this.load();
    //     }
    // }

    public componentDidMount() {
        const { postKey } = this.props;

        // do not need to call onLoad(), initial data are passed from django via html
        const modelAndId = getModelAndId(postKey);
        subscribeJam('comment:' + modelAndId[0] + ':' + modelAndId[1]);
    }

    public componentWillUnmount() {
        const { postKey } = this.props;

        // do not need to call onLoad(), initial data are passed from django via html
        const modelAndId = getModelAndId(postKey);
        unsubscribeJam('comment:' + modelAndId[0] + ':' + modelAndId[1]);
    }

    public render() {
        const {
            loadingState, comments, requestUser, requestUserPermissions, mobile, postKey, location,
            inGroups, initialValues, inPrivateGroup, isIOS, count, complaintsOpened, canAdd,
            location: { hash }, moderators, onReport, onSendHeart, onToggleMenuMore,
        } = this.props;

        const id = parseFloat(getModelAndId(postKey)[1]);
        const hashValue = hash && hash.indexOf('-') !== -1 ? hash.split('-')[1] : null;
        let highlightedId = hashValue === 'last' && comments && comments.length > 0 ? comments[comments.length - 1].id : parseFloat(hashValue);
        if (isNaN(highlightedId)) {
            highlightedId = null;
        }

        return (
            <div className={styles.Comments}>
                {loadingState !== LoadingState.FAILURE && loadingState !== LoadingState.FAILURE_ON_SERVER ?
                    <CommentList
                        comments={comments}
                        requestUser={requestUser}
                        requestUserPermissions={requestUserPermissions}
                        canAdd={canAdd}
                        postId={id}
                        count={count}
                        highlightedId={highlightedId}
                        isIOS={isIOS}
                        mobile={mobile}
                        moderators={moderators}
                        postKey={postKey}
                        loadingState={loadingState}
                        inGroups={inGroups}
                        initialValues={initialValues}
                        inPrivateGroup={inPrivateGroup}
                        complaintsOpened={complaintsOpened}
                        location={location.pathname}
                        onCreate={this.onCreate}
                        onLike={this.onLike}
                        onReply={this.onReply}
                        onDelete={this.onDelete}
                        onReport={onReport}
                        onSendHeart={onSendHeart}
                        onToggleMenuMore={onToggleMenuMore}
                    /> : null
                }

                {isFailure(loadingState) ? (
                    <LoadError onRetry={this.load} />
                ) : null}
            </div>
        );
    }

    public componentWillMount() {
        const { comments, count, isPreloaded } = this.props;
        if (!isPreloaded && comments.length !== count) {
            this.load();
        }
    }

    private load = () => {
        const { onLoad, postKey } = this.props;
        onLoad(postKey);
    };

    private onCreate = (commentFd: CommentFormData) => {
        const { onCreate, postKey } = this.props;
        onCreate(commentFd, postKey);
    };

    private onLike = (commentId: number) => {
        this.props.onLike('comment', commentId);
    };

    private onReply = (username: string) => {
        const { postKey, onReply } = this.props;
        const id = parseFloat(getModelAndId(postKey)[1]);
        onReply(id, username);
    };

    private onDelete = (commentId: number) => {
        const { postKey, onDelete } = this.props;
        onDelete(commentId, postKey);
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { postKey } = ownProps;

    const comments = ownProps.inGroups
        ? getCommentsComments(state, postKey)
        : getCommentsNonDeletedComments(state, postKey);
    const requestUser = getRequestUser(state);

    return {
        comments,
        loadingState: getCommentsLoadingState(state, postKey),
        errorMessage: getCommentsErrorMessage(state, postKey),
        // Never allow canAdd for non-authenticated users
        canAdd: isAuthenticated(requestUser) && getCommentsCanAdd(state, postKey),
        requestUser,
        requestUserPermissions: getRequestPermissions(state),
        renderedAt: getResponseRenderedAt(state),
        isIOS: getRequestDeviceIsIOS(state),
        mobile: getRequestDeviceMobile(state),
        initialValues: {
            text: '',
            photos: [],
            sticker: null,
        },
        complaintsOpened: comments.map((comment) => {
            return getComplaintShow(state, 'photoblog-comment', comment.id);
        }),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLoad: commentsLoad,
    onLike: likeToggle,
    onCreate: commentCreate,
    onDelete: commentDelete,
    onReply: commentReply,
    onReport: (entity: string, id: number) => complaintInitToggle(entity, id, true),

    onFailureToast: () => toastAdd('error', {
        component: ServerErrorToast,
    }),
    onSendHeart: postSendHeart,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comments));
